import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentStatusesApiService extends ApiService {
  constructor() {
    super();
  }

  public getDocumentStatuses$(): Observable<DocumentStatusDto[]> {
    return this.get('/documentStatuses');
  }

  createDocumentStatus$(name: string): Observable<DocumentStatusDto> {
    return this.put(`/documentStatuses/${name}`);
  }
}

export interface DocumentStatusDto {
  id: number;
  name: string;
}

export const apiDocumentStatusesProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiDocumentStatuses.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiDocumentStatuses.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiDocumentStatuses.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiDocumentStatuses.scopes.write],
  },
];
